import React, { useMemo, useState } from "react";
import {
  Breadcrumb,
  Button,
  Form,
  Input,
  InputNumber,
  Row,
  Col,
  Select,
  Space,
  Tree,
  Divider,
  Tooltip,
} from "antd";
import { Link } from "react-router-dom";

import "../../../styles/Main.scss";
import SearchIcon from "../../../image/SearchIcon.svg";

const { Search } = Input;

const MOCK_TREE_DATA = [
  {
    title: "Apex Business Park",
    key: "0",
    type: "Building",
    level: 0,
    locationName: "Apex Business Park",
    locationType: "Building",
    hierarchyLevel: "Level 0 (Project)",
    bomProfile: "",
    area: null,
    children: [
      {
        title: "Block A (IT Tower)",
        key: "0-0",
        type: "Block",
        level: 1,
        locationName: "Block A (IT Tower)",
        locationType: "Block",
        hierarchyLevel: "Level 1 (Block)",
        bomProfile: "",
        area: null,
        children: [
          {
            title: "Ground Floor",
            key: "0-0-0",
            type: "Floor",
            level: 2,
            locationName: "Ground Floor",
            locationType: "Floor",
            hierarchyLevel: "Level 2 (Floor)",
            bomProfile: "",
            area: null,
            children: [
              {
                title: "Main Lobby (Common)",
                key: "0-0-0-0",
                type: "Common Area",
                level: 3,
                locationName: "Main Lobby (Common)",
                locationType: "Common Area",
                hierarchyLevel: "Level 3 (Common Area)",
                bomProfile: "Lobby Type A",
                area: 2500,
              },
            ],
          },
          {
            title: "5th Floor",
            key: "0-0-1",
            type: "Floor",
            level: 2,
            locationName: "5th Floor",
            locationType: "Floor",
            hierarchyLevel: "Level 2 (Floor)",
            bomProfile: "",
            area: null,
            children: [
              {
                title: "Suite 501",
                key: "0-0-1-0",
                type: "Leasable Unit",
                level: 3,
                locationName: "Suite 501",
                locationType: "Leasable Unit",
                hierarchyLevel: "Level 3 (Unit)",
                bomProfile: "Small Office Type A",
                area: 1250,
              },
              {
                title: "Suite 502",
                key: "0-0-1-1",
                type: "Leasable Unit",
                level: 3,
                locationName: "Suite 502",
                locationType: "Leasable Unit",
                hierarchyLevel: "Level 3 (Unit)",
                bomProfile: "Small Office Type A",
                area: 1250,
              },
            ],
          },
        ],
      },
      {
        title: "Block B",
        key: "0-1",
        type: "Block",
        level: 1,
        locationName: "Block B",
        locationType: "Block",
        hierarchyLevel: "Level 1 (Block)",
        bomProfile: "",
        area: null,
      },
    ],
  },
];

const ProjectStructure = () => {
  const [selectedKeys, setSelectedKeys] = useState([]);
  const [expandedKeys, setExpandedKeys] = useState(["0", "0-0", "0-0-0", "0-0-1"]);
  const [searchValue, setSearchValue] = useState("");
  const [form] = Form.useForm();
  const [selectedNode, setSelectedNode] = useState(null);

  const findNodeByKey = (key, tree = MOCK_TREE_DATA) => {
    for (const node of tree) {
      if (node.key === key) {
        return node;
      }
      if (node.children) {
        const found = findNodeByKey(key, node.children);
        if (found) return found;
      }
    }
    return null;
  };

  const onSelect = (selectedKeysValue, info) => {
    setSelectedKeys(selectedKeysValue);
    if (selectedKeysValue.length > 0) {
      const node = findNodeByKey(selectedKeysValue[0]);
      if (node) {
        setSelectedNode(node);
        form.setFieldsValue({
          locationName: node.locationName,
          locationType: node.locationType,
          bomProfile: node.bomProfile || undefined,
          area: node.area || undefined,
        });
      }
    } else {
      setSelectedNode(null);
      form.resetFields();
    }
  };

  const filteredTreeData = useMemo(() => {
    if (!searchValue) return MOCK_TREE_DATA;

    const filterTree = (nodes) => {
      return nodes
        .map((node) => {
          const matches = node.title.toLowerCase().includes(searchValue.toLowerCase());
          const children = node.children ? filterTree(node.children) : [];

          if (matches || children.length > 0) {
            return { ...node, children: children.length > 0 ? children : node.children };
          }
          return null;
        })
        .filter(Boolean);
    };

    return filterTree(MOCK_TREE_DATA);
  }, [searchValue]);

  const handleSave = () => {
    form.validateFields().then((values) => {
      // eslint-disable-next-line no-console
      console.log("Save Project Structure", { selectedNode, values });
    });
  };

  const handleAddChild = () => {
    // eslint-disable-next-line no-console
    console.log("Add Child Location", selectedNode);
  };

  const handleMove = () => {
    // eslint-disable-next-line no-console
    console.log("Move Location", selectedNode);
  };

  const handleDelete = () => {
    // eslint-disable-next-line no-console
    console.log("Delete Location", selectedNode);
  };

  return (
    <>
      <div className="ListingTopBar">
        <div className="pagenamewrap">
          <div className="pagename">
            <Tooltip title="Define and manage hierarchical project structure">
              <h3>Project Structure Editor: Apex Business Park</h3>
            </Tooltip>
            <Breadcrumb className="Breadcrumb-Sec">
              <Breadcrumb.Item>
                <Link to="/dashboard">Home</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>Material Indent</Breadcrumb.Item>
              <Breadcrumb.Item>Project Setup</Breadcrumb.Item>
            </Breadcrumb>
          </div>
          <div style={{ marginLeft: "auto" }}>
            <Button
              type="primary"
              className="SaveGradiantBtn"
              onClick={handleSave}
            >
              Save Project Structure
            </Button>
          </div>
        </div>
      </div>

      <section className="grid-sec FormSection Container">
        <div className="FormBody">
        <Row gutter={[24]} style={{height: "100%"}}>
            <Col xs={24} md={12} lg={12}>
            <div className="columnbox">
              <div className="boxtitle">Structure Navigator</div>

              <Space wrap direction="horizontal" size="middle" style={{ width: "100%", marginBottom: "16px", gap: "10px" }}>
                <Search
                                   style={{width: "100%"}}
                  placeholder="Search Project Hierarchy"
                  value={searchValue}
                  onChange={(e) => setSearchValue(e.target.value)}
                  allowClear
                  prefix={
                    <img
                      src={SearchIcon}
                      alt="SearchIcon"
                      className="SearchIcon"
                      width={22}
                    />
                  }
                />
                <Button type="primary" size="small" className="SaveGradiantBtn" onClick={() => {
                  // eslint-disable-next-line no-console
                  console.log("Bulk Generate Wizard");
                }}>
                  Bulk Generate Wizard
                </Button>
              </Space>

              <Tree
                  treeData={filteredTreeData}
                  selectedKeys={selectedKeys}
                  expandedKeys={expandedKeys}
                  onSelect={onSelect}
                  onExpand={setExpandedKeys}
                  defaultExpandAll={false}
                />
              </div>
            </Col>

            <Col xs={24} md={12} lg={12}>
            <div className="columnbox">
              <div className="boxtitle">Location Inspector &amp; Configurator</div>
              {selectedNode ? (
                <>
                 
                  <div className="po-good-header" style={{marginBottom:'10px'}}>
                  <div className="po-header-details" >
                   <div className="po-row"><strong>Edit Location: </strong><span>{selectedNode.locationName}</span></div>
                  </div>
                    </div>

                  <Form form={form} layout="vertical">
                    
                    <Divider orientation="left" plain orientationMargin={0} style={{ marginBottom: '5px', marginTop: '0px' }}>
                  <div className="returninfo-title">1. General Properties</div>
                </Divider>
                    <Row gutter={[15]}>
                      <Col xs={24} sm={12} >
                        <Form.Item
                          label="Location Name"
                          name="locationName"
                          rules={[{ required: true, message: "Location name is required" }]}
                        >
                          <Input placeholder="Enter location name" />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={12} >
                        <Form.Item
                          label="Location Type"
                          name="locationType"
                          rules={[{ required: true, message: "Location type is required" }]}
                        >
                          <Select
                            placeholder="Select location type"
                            options={[
                              { label: "Building", value: "Building" },
                              { label: "Floor", value: "Floor" },
                              { label: "Leasable Unit", value: "Leasable Unit" },
                              { label: "Common Area", value: "Common Area" },
                            ]}
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} >
                        <Form.Item label="Hierarchy Level" name="hierarchyLevel">
                          <Input disabled />
                        </Form.Item>
                        <div className="muted-text" style={{ fontSize: "12px", marginTop: "-8px" }}>
                          (Read-only based on tree position)
                        </div>
                      </Col>
                    </Row>
                    <Divider orientation="left" plain orientationMargin={0} style={{ marginBottom: '5px', marginTop: '16px' }}>
                  <div className="returninfo-title">2. Inventory &amp; BOM Configuration</div>
                </Divider>
                    
                    <Row gutter={[15]}>
                      <Col xs={24} sm={12} >
                        <Form.Item label="BOM Profile (Bill of Material)" name="bomProfile">
                          <Select
                            placeholder="Select BOM profile"
                            allowClear
                            options={[
                              { label: "Small Office Type A", value: "Small Office Type A" },
                              { label: "Large Office Type B", value: "Large Office Type B" },
                              { label: "Lobby Type A", value: "Lobby Type A" },
                              { label: "Common Area Standard", value: "Common Area Standard" },
                            ]}
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={12} >
                        <Form.Item label="Area (sq ft)" name="area">
                          <InputNumber
                            placeholder="Enter area"
                            style={{ width: "100%" }}
                            min={0}
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                    <Divider orientation="left" plain orientationMargin={0} style={{ marginBottom: '5px', marginTop: '16px' }}>
                  <div className="returninfo-title">3. Actions</div>
                </Divider>
                   
                    <Space size="middle" wrap>
                      <Button type="primary" className="SaveGradiantBtn" onClick={handleAddChild}>
                        Add Child Location below this
                      </Button>
                      <Button type="primary" className="SaveGradiantBtn" onClick={handleMove}>Move Location</Button>
                      <Button type="primary" className="rejectBtn" onClick={handleDelete}>
                        Delete
                      </Button>
                    </Space>
                  </Form>
                </>
              ) : (
                <div className="muted-text" style={{ padding: "40px", textAlign: "center" }}>
                  Select a location from the tree to edit its properties
                </div>
              )}
              </div>
            </Col>
          </Row>
        </div>
      </section>
    </>
  );
};

export default ProjectStructure;
